module.exports = __webpack_public_path__ + "static/media/ball_3_4.6ec8edac.mp3";